import ComponentePlantilla from '@/views/ComponentePlantilla.vue'
import PxTableEjemplo from '@/views/table/PxTableEjemplo.vue'
import PxEjemploFormulario from '@/components/ComponentesPlantilla/PxEjemploFormulario'
import index from '@/views/inicio.vue'
import activacion from '@/views/activacion.vue'

const DEFAULT_TITLE = 'SIAHE -'

export default [
    {
        path: '/activacion/:codigo/:guid',
        name: 'activacion',
        component: activacion,
        meta: { clave: null, permiso: false }
    },
    {
        path: '/',
        name: 'Inicio',
        component: index,
        meta: { clave: null, permiso: false }
    },
    {
        path: '/ComponentePlantilla',
        name: 'ComponentePlantilla',
        component: ComponentePlantilla,
        meta: { clave: null, permiso: false }
    },
    {
        path: '/tableVuesax',
        name: 'tableVuesax',
        component: PxTableEjemplo,
        meta: { clave: null, permiso: false }
    },
    {
        path: '/formulario',
        name: 'formulario',
        component: PxEjemploFormulario,
        meta: { clave: null, permiso: false }
    },

    { path: `${process.env.VUE_APP_SERVER_PROYECTOS}`,      name: '000001' },
    { path: `${process.env.VUE_APP_SERVER_CATALOGOS}`,      name: '000002' },
    { path: `${process.env.VUE_APP_SERVER_CALENDARIZADO}`,  name: '000003' },
    { path: `${process.env.VUE_APP_SERVER_SEGURIDAD}`,      name: '000004' },
    { path: `${process.env.VUE_APP_SERVER_HERRAMIENTAS}`,   name: '000005' },
    { path: `${process.env.VUE_APP_SERVER_PROYECTOS}`,      name: '000006' },


 
]